import {React, useEffect, useState, Fragment} from 'react'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import {Paper, Grid, Typography, TextField, MenuItem, Zoom, Table, TableBody, TableHead, TableContainer, TableCell, TableRow, 
        Fab, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Switch,
    Radio, RadioGroup, FormControlLabel, FormControl} from '@material-ui/core/'
import AddIcon from '@material-ui/icons/Add';
import {authFetch, logout} from '../../auth';


import MarketName from '@material-ui/icons/CalendarViewDay';
import Area from '@material-ui/icons/CropFree';
import State from '@material-ui/icons/RadioButtonChecked';
import EventIcon from '@material-ui/icons/Event';
import CodeIcon from '@material-ui/icons/ListAlt';
import {DatePicker} from '@material-ui/pickers';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import Incum from '@material-ui/icons/Layers';
import Agent from '@material-ui/icons/SortByAlpha';
import ORCode from '@material-ui/icons/SettingsEthernet';
import LabelIcon from '@material-ui/icons/Label';
import ViewListIcon from '@material-ui/icons/ViewList';
import TextsmsIcon from '@material-ui/icons/Textsms';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import TimelineIcon from '@material-ui/icons/Timeline';
import { set } from 'date-fns';

const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.secondary.main,
      padding: 3
    },
    body: {
      fontSize: 14,
      color: theme.palette.primary.dark,
      padding: 5
    },
  }))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: theme.spacing(2)
    },
    sectionTitle: {
        marginBottom: 10,
        backgroundColor: theme.palette.secondary.light,
        borderRadius: 3,
        color: theme.palette.primary.dark
    },
    formPaper: {
        padding: theme.spacing(3),
        color: theme.palette.primary.main,
        "> * + *": {
            marginTop: theme.spacing(5)
        }
    }, 
    formRow: {
        width: "100%",       
        maxHeight: "50%",        
    },
    labelText: {
        color: theme.palette.primary.main,
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: 16 
    },
    dialogContent: {
        fontSize: 14,
        color: theme.palette.primary.main,
    },
    dialogTitle: {
        fontSize: 14,
        color: theme.palette.primary.main,
        fontWeight: 'normal'
    },
    formText: {
        fontSize: 14,
        color: theme.palette.primary.main,
        textAlign: "left",
        marginLeft: theme.spacing(1)
    },
    formDefined: {
        backgroundColor: theme.palette.secondary.light,        
    },
    formDateText: {
        fontSize: 14,
        color: theme.palette.primary.main,
        textAlign: "left",
    },
    formItemNoPadding: {
        padding: 0
    },
    uploadButton : {
        fontSize: 14,
        [theme.breakpoints.down('xs')]: {
          fontSize: 8,
        },
    }
  }));



export default function Summary(props) {
    const classes = useStyles();    
    //const [inputPeriod, setInputPeriod] = useState(periods[actualMonth-1]);
 
    const [actorDialog, setActorDialog] = useState(false) 
    const [feedbackDialog, setFeedbackDialog] = useState(false) 
    const [feedbackMsg, setFeedbackMsg] = useState("")

    const [methodsList, setMethodsList] = useState([])
    const [methodData, setMethodData] = useState({})

    const [withIndexation, setWithIndexation] = useState(true)

    const handleActorDialogOpen = () => {
        setActorDialog(true);
      };
    
    const handleActorDialogClose = () => {
        setActorDialog(false);
    };

    const handleFeedbackDialogOpen = () => {
        setFeedbackDialog(true);
      };
    
    const handleFeedbackDialogClose = () => {
        setFeedbackDialog(false);
    };

    const updateValuesWithSelectedActor = (idx) => {
        if (idx === -1){
            setMethodData({active: true})
        }
        else{
            setMethodData(methodsList[idx])
        }
    }
 
    const handleActorUpload = () => {     
        //console.log(conceptData)   
        if (!methodData.calc_name || !methodData.description || !methodData.affected_var
            || !methodData.period || !methodData.key_source
        ){
            handleFeedbackDialogOpen()
            setFeedbackMsg("Algunos campos estan vacíos. Ingreso inválido.")
        }   
        else {            
            if (!methodData['id']){
                methodData['username'] = props.username
            }            
            authFetch(
            "/api/update-calc-methods",
            {
                method: 'post',
                body: JSON.stringify(methodData),
            }
            ).then(r => {
              if (r.status === 422){
                logout()
                return null
              }
              else{
                return r.json()
              }
            })
            .then(response => {
                if (response.Upload === 'OK'){
                setFeedbackMsg('Datos guardados. Verifique la información reflejada en la lista.')
                handleFeedbackDialogOpen()
                handleActorDialogClose()
                authFetch("/api/check-calc-methods?username="+props.username+"&user_type="+props.user_type).then(response => {
                    if (response.status === 422){
                        logout()
                        return null
                    }
                        return response.json()
                    }).then(response => {
                        if (response && response.methods){                    
                            setMethodsList(response.methods)
                        }
                    })
                }
                else {
                    setFeedbackMsg('Error al guardar los datos.')
                    handleFeedbackDialogOpen()
                }
            })
        }     
    }

    const showFeedbackDialog = () => (
        <Dialog
            open={feedbackDialog}
            onClose={handleFeedbackDialogClose}       
            className={classes.formText}            
        >
        <DialogTitle className={classes.dialogTitle} style={{textAlign: 'center'}}>Aviso</DialogTitle>
        <DialogContent className={classes.dialogContent}>
            <DialogContentText>
                {feedbackMsg}
            </DialogContentText>
        </DialogContent>
        <DialogActions>          
          <Button onClick={handleFeedbackDialogClose} color="primary" autoFocus>
            Aceptar
          </Button>
        </DialogActions>
        </Dialog>
    )
 
    const showActorDialog = () => (
      <Dialog
            open={actorDialog}
            onClose={handleActorDialogClose}       
            className={classes.formText}
            scroll={'paper'}
            maxWidth={'md'}
        >
        <DialogTitle className={classes.dialogTitle} style={{textAlign: 'center'}}>{"Ingresar/Revisar los datos de la metodología."}</DialogTitle>
        <DialogContent className={classes.dialogContent}>                     
            <Grid container spacing={1} alignItems="flex-start" justify="space-evenly">                
                <Grid item xs={6}>
                    <Grid container spacing={2}>                        
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" align="left">Cargo de aplicación:</Typography>
                        </Grid>
                        <Grid item>
                            <LabelIcon/>
                        </Grid>
                        <Grid item xs={9}>
                            <TextField
                                disabled={methodData.id ? true : false}                    
                                value={methodData.affected_var}
                                placeholder={"Selecciona un cargo"}
                                InputProps={{
                                    readOnly: methodData.id ? true : false,
                                    className:methodData.id ?classes.formDefined : {},
                                    classes: {
                                        input: classes.formText
                                    }
                                }}
                                variant="standard"
                                className={classes.formRow}   
                                onChange={(e) => setMethodData({...methodData, affected_var: e.target.value})}
                                select
                            >
                                <MenuItem value="Comercialización">{'Comercialización'}</MenuItem>
                                <MenuItem value="Generación">{'Generación'}</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" align="left">Nombre:</Typography>
                        </Grid>
                        <Grid item>
                            <ViewListIcon/>
                        </Grid>
                        <Grid item xs={9}>
                            <TextField
                                multiline
                                disabled={methodData.id ? true : false}           
                                value={methodData.calc_name}
                                placeholder={"Ingresa un nombre"}
                                variant="standard"
                                InputProps={{
                                    readOnly: methodData.id ? true : false,
                                    className:methodData.id ?classes.formDefined : {},
                                    classes: {
                                        input: classes.formText
                                    }
                                }}
                                className={classes.formRow}   
                                onChange={(e) => setMethodData({...methodData, calc_name: e.target.value})}                            
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" align="left">Descripción:</Typography>
                        </Grid>
                        <Grid item>
                            <TextsmsIcon/>
                        </Grid>
                        <Grid item xs={9}>
                            <TextField
                                value={methodData.description}
                                placeholder={"Ingresa una descripción"}
                                variant="standard"
                                InputProps={{
                                    classes: {
                                        input: classes.formText
                                    }
                                }}
                                className={classes.formRow}   
                                onChange={(e) => setMethodData({...methodData, description: e.target.value})}                            
                                multiline
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" align="left">Aplica indexación</Typography>
                        </Grid>
                        <Grid item xs={10}>
                            <Switch
                                checked={withIndexation}
                                onChange={(e) => setWithIndexation(e.target.checked)}
                                color="primary"
                                disabled={methodData.id ? true : false}
                            />
                            {withIndexation? 'Sí':'No'}
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" align="left">Variable de indexación:</Typography>
                        </Grid>
                        <Grid item>
                            <TimelineIcon/>
                        </Grid>
                        <Grid item xs={9}>
                            <TextField
                                disabled={methodData.id ? true : false}                    
                                value={methodData.indexation_var}
                                placeholder={"Selecciona una variable de indexación"}
                                variant="standard"
                                InputProps={{
                                    readOnly: methodData.id ? true : false,
                                    className:methodData.id ?classes.formDefined : {},
                                    classes: {
                                        input: classes.formText
                                    }
                                }}
                                className={classes.formRow}   
                                onChange={(e) => setMethodData({...methodData, indexation_var: e.target.value})}                            
                                select
                            >
                                <MenuItem value="IPC">{'IPC'}</MenuItem>
                                <MenuItem value="IPP">{'IPP'}</MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>                                       
                </Grid>     

                <Grid item xs={6}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" align="left">Periodicidad de aplicación:</Typography>
                        </Grid>
                        <Grid item xs={10}>
                             <FormControl component="fieldset" disabled={methodData.id ? true : false}>
                                <RadioGroup row name="dual-selector" value={methodData.period} onChange={(e) => setMethodData({...methodData, period: e.target.value})}>
                                    <FormControlLabel
                                        value="Mensual"
                                        control={<Radio color="primary"/>} // Naranja
                                        label="Mensual"
                                    />
                                    <FormControlLabel
                                        value="Anual"
                                        control={<Radio color="primary"/>} // Verde
                                        label="Anual"
                                    />
                                </RadioGroup>
                            </FormControl>
                        </Grid>                         
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" align="left">Estado:</Typography>
                        </Grid>
                        <Grid item xs={10}>
                            <Switch
                                checked={methodData.active}
                                onChange={(e) => setMethodData({...methodData, active: e.target.checked})}
                                color="primary"                                                 
                            />
                            {methodData.active? 'Activo':'Inactivo'}
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" align="left">LLave:</Typography>
                        </Grid>
                        <Grid item>
                            <VpnKeyIcon/>
                        </Grid>
                        <Grid item xs={9}>
                            <TextField
                                value={methodData.key_source}
                                placeholder={"Contacte con el administrador del sistema para obtener la llave"}
                                variant="standard"
                                InputProps={{
                                    readOnly: methodData.id ? true : false,
                                    className:methodData.id ?classes.formDefined : {},
                                    classes: {
                                        input: classes.formText
                                    }
                                }}
                                className={classes.formRow}   
                                onChange={(e) => setMethodData({...methodData, key_source: e.target.value})}
                                disabled={methodData.id ? true : false}
                            />
                        </Grid>                        
                    </Grid>                    
                </Grid>                           
                <Grid item>
                     <Fab
                        color="secondary"
                        size="small"
                        component="span"
                        aria-label="add"
                        variant="extended"                        
                        classes={{root: classes.uploadButton}}
                        onClick={handleActorUpload}
                        style={{marginTop: 20}}
                    > 
                        <Fragment><SaveIcon /> {' Guardar  '}</Fragment>                         
                    </Fab>
                </Grid>                   
                <Grid item>
                    <Fab
                        color="secondary"
                        size="small"
                        component="span"
                        aria-label="add"
                        variant="extended"                        
                        classes={{root: classes.uploadButton}}
                        onClick={handleActorDialogClose}
                        style={{marginTop: 20}}
                    > 
                        <Fragment><CancelIcon /> {'Cancelar'}</Fragment>                         
                    </Fab>
                </Grid>
            </Grid>            
        </DialogContent>        
      </Dialog>
    )

    useEffect (() => {
        document.title ="Metodologías de cálculo";
        
        authFetch("/api/check-calc-methods?username="+props.username+"&user_type="+props.user_type).then(response => {
            if (response.status === 422){
                    logout()
                    return null
                }
                return response.json()
            }).then(response => {
                if (response && response.methods){                    
                    setMethodsList(response.methods)
                }
            })
        
    }, [])

    return (
        <div className={classes.root}>
            {showActorDialog()}
            {showFeedbackDialog()}
            <Grid container justify="space-evenly">
                <Zoom in timeout={800}>
                        <Grid item xs={11}>
                            <Typography variant="subtitle1" className={classes.sectionTitle}>Parametrización de metodologías:</Typography>
                            <TableContainer component={Paper}>
                                <Table aria-label="markets table">
                                    <TableHead>
                                    <TableRow>
                                        <StyledTableCell align="center" style={{width: "15%"}}>Cargo de aplicación</StyledTableCell>
                                        <StyledTableCell align="center" style={{width: "15%"}}>Nombre</StyledTableCell>
                                        <StyledTableCell align="center" style={{width: "35%"}}>Descripción</StyledTableCell>
                                        <StyledTableCell align="center" style={{width: "15%"}}>Variable de indexación</StyledTableCell>
                                        <StyledTableCell align="center" style={{width: "15%"}}>Periodicidad</StyledTableCell>
                                        <StyledTableCell align="center" style={{width: "15%"}}>Estado</StyledTableCell>
                                    </TableRow>
                                    </TableHead>
                                    <TableBody>                                           
                                        {methodsList.map((row,idx) => (
                                        <StyledTableRow 
                                            key={idx} 
                                            onClick={() => {updateValuesWithSelectedActor(idx); handleActorDialogOpen();}}
                                        >                                                       
                                            <StyledTableCell align="center" >{row.affected_var}</StyledTableCell>
                                            <StyledTableCell align="center" >{row.calc_name}</StyledTableCell>
                                            <StyledTableCell align="center">{row.description}</StyledTableCell>
                                            <StyledTableCell align="center">{row.indexation_var ? row.indexation_var : '-'}</StyledTableCell>
                                            <StyledTableCell align="center">{row.period}</StyledTableCell>
                                            <StyledTableCell align="center">{row.active ? 'Activo':'Inactivo'}</StyledTableCell>
                                        </StyledTableRow>
                                            
                                        ))}                                            
                                    </TableBody>
                                </Table>
                            </TableContainer> 
                            <Fab
                                color="primary"
                                size="small"
                                component="span"
                                aria-label="add"
                                variant="extended"                        
                                classes={{root: classes.uploadButton}}
                                onClick={() =>{updateValuesWithSelectedActor(-1); handleActorDialogOpen();}}
                                style={{marginTop: 20}}
                            > 
                                <Fragment><AddIcon /> {' Agregar '}</Fragment>                         
                            </Fab>      
                        </Grid>                                                        
                </Zoom>                
            </Grid>       
        </div>
    );
}